import React from "react";

export default function FILTVChannelChip({ channel, active, onClick }) {
    return (
        <button
            onClick={onClick}
            className={`relative flex flex-col items-center justify-center min-w-[64px] rounded-xl px-2 py-2 border transition-all duration-200 active:scale-95
            ${active
                ? "bg-purple-700 border-purple-400 shadow-lg shadow-purple-700/40"
                : "bg-zinc-900 border-zinc-800 hover:border-zinc-600"
            }`}
        >
            <span className="text-xl leading-none">{channel.emoji}</span>
            <span className="text-[10px] mt-1 text-zinc-200 font-semibold">{channel.lcn}</span>

            <span
                className={`absolute top-1 right-1 w-1.5 h-1.5 rounded-full ${
                    channel.hasAd ? "bg-red-500 animate-pulse" : "bg-zinc-600"
                }`}
            />
        </button>
    );
}
